// export const Global = {
//   url: "http://localhost:8000/api/v1/",
//   media: "http://localhost:8000/"
//   // url: "https://coronatours-baf05d27dc47.herokuapp.com/api/",
// };

export const Global = {
  url: "https://api.gegova.com.co/api/v1/",
  media: "https://api.gegova.com.co/"
  // url: "https://coronatours-baf05d27dc47.herokuapp.com/api/",
};